/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Baseload_HelpInputs */



/**
* | output |
* | --- |
* | "The building's lowest consumption, computed over the lowest 10 % of readings." |
*
* @param {Consumption_Baseload_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_baseload_help = /** @type {((inputs?: Consumption_Baseload_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Baseload_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The building's lowest consumption, computed over the lowest 10 % of readings.")
	return /** @type {LocalizedString} */ ("La consommation la plus basse du bâtiment, calculée sur les 10 % de mesures les plus faibles.")
});